var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContentTop',[_c('img',{attrs:{"src":require("../assets/images/icon.png"),"alt":""}}),_c('span',[_vm._v(" 请选择系统查重")])]),_c('div',{staticClass:"step"},[_c('Step')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }